import { Icon } from "@iconify/react";
import WebpImage from "./WebpImage";
import { useTranslation } from "react-i18next";
import Container from "@/Components/Grid/Container";
import Row from "@/Components/Grid/Row";
import Column from "@/Components/Grid/Column";
import { Link } from "@inertiajs/react";
import resolveLocaleRoute from "@/Helpers/resolveLocaleRoute";

const FrontViewOnMap = ({link}) => {
    const { t, i18n } = useTranslation();

    return (
        <Container>
            <Row className="justify-center">
                <Column removePaddingMobile>
                    {/* =================== [Dodatek, po akceptacji podmienić klasę na [lg:h-[226px] md:h-52 h-40]] =================== */}
                    <div className="google-map lg:h-[226px] md:h-52 h-40 relative">
                        <WebpImage
                            sources={[
                                {
                                    width: 768,
                                    path: `/storage/images/map-placeholder-size-1300`,
                                    mime: "jpg",
                                },
                                {
                                    width: 1,
                                    path: `/storage/images/map-placeholder-size-767`,
                                    mime: "jpg",
                                },
                            ]}
                            alt={t("alts.mapPlaceholder")}
                            fallback={`/storage/images/map-placeholder.jpg`}
                            className="w-full h-full object-cover object-center"
                            seo={{
                                width: 1300,
                                height: 226,
                            }}
                        />
                        <Link
                            href={link}
                            title={t('warehouses.viewOnTheMap')}
                            className="z-c2 bg-dark-blue-standard flex gap-c10 min-h-[52px] py-2 px-7 absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 text-white rounded-lg items-center hover:bg-light-blue transition-all ease-in-out duration-300 w-max"
                        >
                            <span>{t("warehouses.viewOnTheMap")}</span>
                            <Icon
                                icon={"mdi:magnify"}
                                height={24}
                                width={24}
                                className="shrink-0"
                            />
                        </Link>
                    </div>
                </Column>
            </Row>
        </Container>
    );
};

export default FrontViewOnMap;
